import type { Components, Theme } from "@mui/material/styles";
import { Button } from "./button";

export const components: Components<Theme> = {
  MuiButton: {
    ...Button,
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root": {
          borderRadius: 8,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#3c3759",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#3c3759",
          },
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: "none",
        fontWeight: 600,
        minWidth: "auto",
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        height: 3,
      },
    },
  },
};
